import React from 'react';

const SplashScreen = () => (
  <div style={{ display: 'flex',justifyContent: 'center',alignItems: 'center',height: '100vh' }}>
    <img src={require("./images/loading.gif")} alt="Loading..." />
  </div>
);

export default SplashScreen;